import React from 'react'
import { Grid, Link, Divider } from '@material-ui/core'
import Styles from '../components/preFooter.module.scss'

const remodelmateLogo = "https://remodelmate-v2-local.s3.us-east-2.amazonaws.com/branding/logos/abstractmark/svg/remodelmate-symbol-black.svg"
const remodelmateEstimateUrl = "https://remodelmate.com/estimate/1"

function PreFooter() {
    return (
        <div className={Styles.prefooterOuter}>
            {/* Logo Grid */}
            <Grid container justify="center" alignItems="center" className={Styles.prefooterInner}>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                  <div className={Styles.prefooterLogoImageContainer}>
                    <img
                        src={remodelmateLogo}
                        alt="remodelmateLogo"
                        className={Styles.prefooterLogoImage}
                    />
                  </div>
                  <div className={Styles.dividerMobile}>
                    <Divider
                        
                    />
                  </div>
                </Grid>

                {/* Content Grid */}
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8} className={Styles.prefooterGridItem}>
                    <h3 className={Styles.prefooterGridItemH3}>
                        Build the bathroom of your dreams.
                    </h3>
                    <h3 className={Styles.prefooterGridItemH3}>
                        Get your estimate instantly.
                    </h3>
                </Grid>

                {/* Button Grid */}
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className={Styles.prefooterGridItem3}>
                        <Link
                            href={remodelmateEstimateUrl}
                        >
                            <button
                                className={Styles.preFooterButtonFill}
                            >
                                Start Now
                            </button>
                        </Link>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default PreFooter